export default __webpack_public_path__ + "static/safari_logo-f16cc5246095e82d86a34829899b7ee3.svg";